const jobfairForm = () => {
  const form = document.querySelector('form');
  const observer = new MutationObserver((mutations) => {
    const status = mutations[0].target.dataset.status;
    if (status === 'sent') {
      location.href = './thanks';
    }
  });

  observer.observe(form, {
    attribute: true,
    attributeFilter: ['data-status'],
  });
};

export default jobfairForm;
